import { observable } from 'mobx';
import UserProfileStore from './UserProfileStore';
import ProjectsLibraryStore from './ProjectsLibraryStore';
import { EFH2Store } from './EFH2Store';
import { DesignStore } from './DesignStore';
import { SurveyEngineeringStore } from './SurveyEngineeringStore';
import { PitDesignStore } from './PitDesignStore';
import { PadDesignStore } from './PadDesignStore';
import { LandLevelingDesignStore } from './LandLevelingDesignStore';
import { AlignmentDesignStore } from './AlignmentDesignStore';
import { CrossSectionDesignStore } from './SingleCrossSectionDesignStore';
import { ThreeCrossSectionDesignStore } from './ThreeCrossSectionDesignStore';

import { appConfig } from 'cd-eft/config/AppConfig';
import { WaterwayDesignStore } from './WaterwayDesignStore';
import { TerraceDesignStore } from './TerraceDesignStore';
import { UGODesignStore } from './UGODesignStore';

class AppStore {
  constructor() {
    this.userProfileStore = new UserProfileStore(this);
    this.projectsLibraryStore = new ProjectsLibraryStore(this);
    this.efh2Store = new EFH2Store(this);
    this.designStore = new DesignStore(this);
    this.surveyEngineeringStore = new SurveyEngineeringStore(this);
    this.pitDesignStore = new PitDesignStore(this);
    this.padDesignStore = new PadDesignStore(this);
    this.alignmentDesignStore = new AlignmentDesignStore(this);
    this.landLevelingDesignStore = new LandLevelingDesignStore(this);
    this.crossSectionDesignStore = new CrossSectionDesignStore(this);
    this.threeCrossSectionDesignStore = new ThreeCrossSectionDesignStore(this);
    this.waterwayDesignStore = new WaterwayDesignStore(this);
    this.terraceDesignStore = new TerraceDesignStore(this);
    this.ugoDesignStore = new UGODesignStore(this);
    this.appConfig = appConfig;
  }
  @observable userProfileStore: UserProfileStore;
  @observable projectsLibraryStore: ProjectsLibraryStore;
  @observable efh2Store: EFH2Store;
  @observable designStore: DesignStore;
  @observable surveyEngineeringStore: any;
  @observable pitDesignStore: PitDesignStore;
  @observable padDesignStore: PadDesignStore;
  @observable alignmentDesignStore: AlignmentDesignStore;
  @observable landLevelingDesignStore: LandLevelingDesignStore;
  @observable crossSectionDesignStore: CrossSectionDesignStore;
  @observable threeCrossSectionDesignStore: ThreeCrossSectionDesignStore;
  @observable waterwayDesignStore: WaterwayDesignStore;
  @observable terraceDesignStore: TerraceDesignStore;
  @observable ugoDesignStore: UGODesignStore;
  appConfig: typeof appConfig;
  @observable createProjectClassId?: number;
}
export default new AppStore();
